var _g, _ellipse, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTechEyeIllus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 526,
    height: 480,
    viewBox: "0 0 526 480",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_480_351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M495.325 356.953C493.24 378.645 475.875 395.765 457.576 407.581C446.076 415.042 433.498 421.31 420.057 424.199C401.111 428.253 381.446 425.406 362.083 426.183C314.818 428.08 269.81 451.526 222.545 449.628C190.704 448.335 160.33 435.512 133.046 419.053C121.446 412.052 109.788 403.858 103.592 391.74C99.6964 384.15 98.2445 375.54 94.8664 367.705C81.8139 337.518 42.8721 323.89 32.5796 292.668C26.3552 273.793 32.3927 253.151 40.1121 234.837C48.3346 215.287 58.7995 196.125 74.9139 182.297C79.5359 178.396 84.4311 174.832 89.562 171.63C104.742 161.884 121.187 153.762 132.213 139.646C145.236 122.971 148.399 100.747 158.088 81.9018C175.769 47.3012 217.234 26.1719 255.5 33C271.5 34.5 269 30.5 284.544 31C319.532 31.0948 354.471 33.6213 389.108 38.5612C416.694 42.4856 447.154 49.9606 462.032 73.5068C470.226 86.4443 472.224 102.343 473 117.667C474.526 148.157 471.978 178.714 465.425 208.531C464.95 210.73 464.447 212.93 463.987 215.129C460.25 231.315 456.297 247.775 459.2 264.004C465.137 297.196 498.545 323.358 495.325 356.953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M273.907 423.71C341.969 423.71 397.144 407.769 397.144 388.103C397.144 368.438 341.969 352.497 273.907 352.497C205.846 352.497 150.671 368.438 150.671 388.103C150.671 407.769 205.846 423.71 273.907 423.71Z",
    fill: "#04B2AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.111 300.172H249.872C245.792 300.174 241.751 299.371 237.98 297.811C234.209 296.251 230.783 293.963 227.897 291.078C225.011 288.193 222.721 284.768 221.159 280.998C219.597 277.229 218.793 273.188 218.793 269.107V233.63H264.621L256.111 300.172Z",
    fill: "#04B2AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.635 233.63L256.111 300.172H249.872C245.791 300.172 241.751 299.368 237.981 297.806C234.211 296.244 230.786 293.954 227.901 291.068C225.016 288.182 222.728 284.756 221.168 280.985C219.608 277.215 218.806 273.174 218.808 269.093V233.63H264.635Z",
    fill: "url(#paint0_linear_480_351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.625 131.424H287.074V182.383H203.527V172.522C203.527 161.622 207.857 151.168 215.564 143.461C223.271 135.754 233.725 131.424 244.625 131.424Z",
    fill: "#04B2AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.074 131.424V182.383H203.513V172.522C203.513 167.123 204.576 161.778 206.642 156.791C208.709 151.804 211.737 147.272 215.555 143.456C219.373 139.639 223.905 136.612 228.893 134.548C233.881 132.483 239.227 131.422 244.625 131.424H287.074Z",
    fill: "url(#paint1_linear_480_351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.386 209.221C314.386 209.221 322.623 199.374 330.069 202.896C337.516 206.418 326.346 223.941 325.757 230.093C325.167 236.246 317.635 244.756 311.856 241.593C306.077 238.431 314.386 209.221 314.386 209.221Z",
    fill: "#FFBBAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.477 186.379C317.477 186.379 315.81 274.311 295.785 289.06C275.761 303.808 256.11 300.172 256.11 300.172V160.015C256.11 160.015 309.053 158.29 317.477 186.379Z",
    fill: "#FFBBAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.544 142.607C322.107 142.463 320.942 144.045 320.913 145.482C321.056 146.953 321.549 148.367 322.351 149.608C326.06 157.212 327.109 165.765 326.865 174.132C326.635 181.865 324.119 189.944 324.809 197.592C324.996 199.733 325.427 202.033 324.407 203.931C323.571 205.159 322.53 206.233 321.33 207.108C317.233 210.802 315.336 216.293 313.597 221.483C312.993 217.616 313.726 213.677 314.272 209.81C314.818 205.943 315.192 202.033 315.365 198.138C315.465 195.953 316.673 188.909 315.365 187.184C313.783 185.057 310.305 187.702 308.005 188.478C307.228 188.737 298.517 190.95 298.488 190.706L297.655 178.703L275.575 183.518C275.704 181.06 275.575 178.013 273.289 176.963C272.037 176.56 270.689 176.56 269.437 176.963L255.867 179.594C257.419 175.023 253.696 167.102 253.351 162.344C252.704 153.46 255.608 147.523 255.493 138.625C255.493 133.896 253.092 119.061 258.023 116.603C262.953 114.145 274.813 118.328 279.787 119.622C287.359 121.612 294.698 124.402 301.68 127.945C309.538 131.923 316.88 136.847 323.544 142.607Z",
    fill: "#42202E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.99 180.773H256.111V194.472H215.99V180.773Z",
    fill: "#04B2AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.99 180.773H256.111V194.472H215.99V180.773Z",
    fill: "url(#paint2_linear_480_351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.646 187.615H256.111V233.615H206.646C204.561 233.615 202.561 232.787 201.086 231.312C199.612 229.838 198.783 227.838 198.783 225.752V195.479C198.783 193.393 199.612 191.393 201.086 189.918C202.561 188.444 204.561 187.615 206.646 187.615Z",
    fill: "#04B2AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.111 187.615V233.615H206.646C205.613 233.615 204.589 233.412 203.634 233.015C202.679 232.619 201.812 232.039 201.081 231.307C200.351 230.576 199.772 229.707 199.378 228.751C198.983 227.796 198.781 226.772 198.783 225.738V195.479C198.783 193.393 199.612 191.393 201.086 189.918C202.561 188.444 204.561 187.615 206.646 187.615H256.111Z",
    fill: "url(#paint3_linear_480_351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.341 248.781H248.435L254.199 221.512H256.341V248.781Z",
    fill: "#04B2AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.113 253.467H256.111V279.112H238.113V253.467Z",
    fill: "#04B2AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.951 219.384C275.19 220.337 276.7 220.871 278.263 220.908C284.117 221.622 290.03 221.704 295.901 221.152",
    stroke: "#42202E",
    strokeWidth: 0.921981,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.835 201.286C299.724 201.832 295.612 202.465 291.53 203.212C288.228 203.71 284.992 204.578 281.884 205.8C279.987 206.619 275.919 209.882 273.82 209.063C271.721 208.244 273.029 205.484 274.481 204.75C277.026 203.313 280.634 202.982 283.437 202.45C286.573 201.871 289.741 201.478 292.924 201.272C296.557 201.018 300.203 201.022 303.835 201.286Z",
    fill: "#42202E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.11 268.23C261.633 268.083 267.128 267.385 272.512 266.146",
    stroke: "#42202E",
    strokeWidth: 0.921981,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.45 235.125L263.241 240.487C263.456 241.545 263.456 242.635 263.241 243.693C262.921 244.732 262.312 245.659 261.487 246.366C260.061 247.673 258.271 248.516 256.355 248.781",
    stroke: "#42202E",
    strokeWidth: 0.921981,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.85 221.943C240.614 221.943 245.286 217.271 245.286 211.507C245.286 205.743 240.614 201.07 234.85 201.07C229.086 201.07 224.414 205.743 224.414 211.507C224.414 217.271 229.086 221.943 234.85 221.943Z",
    fill: "url(#paint4_linear_480_351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.85 217.875C238.367 217.875 241.218 215.024 241.218 211.507C241.218 207.99 238.367 205.138 234.85 205.138C231.333 205.138 228.482 207.99 228.482 211.507C228.482 215.024 231.333 217.875 234.85 217.875Z",
    fill: "#FFDA07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.105 131.424V133.235C212.138 133.709 210.7 182.383 210.7 182.383H203.513V172.522C203.513 167.123 204.576 161.778 206.642 156.791C208.709 151.804 211.737 147.272 215.555 143.456C219.373 139.639 223.905 136.612 228.893 134.548C233.881 132.483 239.227 131.422 244.625 131.424H255.105Z",
    fill: "url(#paint5_linear_480_351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.189 187.615V233.615H206.646C205.613 233.615 204.589 233.412 203.634 233.015C202.679 232.619 201.812 232.039 201.081 231.307C200.351 230.576 199.772 229.707 199.378 228.751C198.983 227.796 198.781 226.772 198.783 225.738V195.479C198.783 193.393 199.612 191.393 201.086 189.918C202.561 188.444 204.561 187.615 206.646 187.615H211.189Z",
    fill: "url(#paint6_linear_480_351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.111 292.754V300.172H249.872C245.791 300.172 241.751 299.368 237.981 297.806C234.211 296.244 230.786 293.954 227.901 291.068C225.016 288.182 222.728 284.756 221.168 280.985C219.608 277.215 218.806 273.174 218.808 269.093V233.63H251.64L250.907 237.123H224.414C224.414 237.123 220.331 284.805 236.058 288.873C251.784 292.941 256.111 292.754 256.111 292.754Z",
    fill: "url(#paint7_linear_480_351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.494 211.464C322.85 210.99 323.316 210.611 323.853 210.36C324.389 210.11 324.979 209.995 325.571 210.026C326.043 210.144 326.474 210.386 326.821 210.727C327.167 211.068 327.415 211.497 327.54 211.967C327.782 212.906 327.817 213.887 327.641 214.842C326.872 219.305 325.539 223.652 323.673 227.779C322.121 231.589 320.453 235.585 317.204 238.115C315.968 239.063 314.214 239.768 312.892 238.92C308.924 236.332 311.368 228.268 313.984 225.609C315.868 223.711 317.664 222.863 318.685 220.261C319.95 217.027 320.022 214.137 322.494 211.464Z",
    fill: "#E0A194"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.907 396.096C335.093 396.096 384.695 384.395 384.695 369.962C384.695 355.529 335.093 343.828 273.907 343.828C212.72 343.828 163.119 355.529 163.119 369.962C163.119 384.395 212.72 396.096 273.907 396.096Z",
    fill: "#04B2AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.425 208.56C464.95 210.759 464.447 212.958 463.987 215.158L388.634 370.623C385.657 376.787 380.398 381.551 373.971 383.906C343.87 394.931 252.316 422.531 172.635 385.041C169.475 383.546 166.645 381.436 164.311 378.835C161.976 376.233 160.183 373.193 159.036 369.89L89.562 171.63C104.742 161.884 121.187 153.762 132.213 139.646C145.236 122.971 148.399 100.747 158.088 81.9018C175.769 47.3012 217.341 26.6874 255.607 33.5156C265.124 35.2118 274.884 31.3881 284.544 30.9999C319.532 31.0948 354.471 33.6213 389.108 38.5612C416.694 42.4856 447.154 49.9605 462.032 73.5068C470.226 86.4443 472.224 102.343 473 117.667C474.528 148.166 471.981 178.734 465.425 208.56Z",
    fill: "url(#paint8_linear_480_351)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M445.961 141.86C445.969 146.15 444.458 150.305 441.695 153.588C438.932 156.87 435.096 159.068 430.867 159.792C426.638 160.515 422.289 159.717 418.592 157.54C414.895 155.363 412.088 151.947 410.67 147.897C409.982 145.959 409.632 143.917 409.635 141.86C409.768 137.131 411.74 132.641 415.132 129.343C418.524 126.046 423.068 124.201 427.798 124.201C432.529 124.201 437.073 126.046 440.464 129.343C443.856 132.641 445.828 137.131 445.961 141.86Z",
    fill: "#04B2AE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M440.484 133.983C440.483 137.437 439.497 140.82 437.641 143.733C435.786 146.647 433.137 148.97 430.007 150.431C426.877 151.892 423.395 152.43 419.97 151.981C416.544 151.532 413.318 150.116 410.67 147.898C409.982 145.959 409.632 143.917 409.635 141.86C409.639 138.407 410.627 135.026 412.482 132.114C414.338 129.202 416.986 126.879 420.114 125.418C423.243 123.956 426.723 123.416 430.147 123.861C433.571 124.306 436.798 125.718 439.449 127.931C440.139 129.874 440.489 131.921 440.484 133.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M400.449 165.981C400.459 168.128 399.706 170.209 398.326 171.854C396.945 173.498 395.026 174.6 392.909 174.962C390.793 175.324 388.616 174.924 386.767 173.832C384.918 172.74 383.516 171.028 382.811 169C382.464 168.032 382.289 167.01 382.294 165.981C382.245 164.759 382.444 163.539 382.878 162.395C383.312 161.251 383.973 160.207 384.821 159.325C385.669 158.443 386.686 157.741 387.812 157.261C388.937 156.782 390.148 156.535 391.372 156.535C392.595 156.535 393.806 156.782 394.932 157.261C396.057 157.741 397.074 158.443 397.922 159.325C398.77 160.207 399.431 161.251 399.865 162.395C400.299 163.539 400.498 164.759 400.449 165.981Z",
    fill: "#04B2AE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M397.747 162.042C397.744 163.768 397.249 165.458 396.321 166.913C395.392 168.368 394.069 169.528 392.505 170.258C390.941 170.988 389.201 171.257 387.489 171.035C385.778 170.812 384.165 170.106 382.84 169C382.493 168.032 382.318 167.01 382.323 165.981C382.323 164.254 382.816 162.563 383.744 161.106C384.671 159.649 385.994 158.486 387.559 157.754C389.123 157.023 390.864 156.752 392.577 156.974C394.29 157.197 395.904 157.903 397.23 159.009C397.571 159.984 397.746 161.01 397.747 162.042Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M229.014 84.5755C228.998 87.5357 227.974 90.4023 226.111 92.7028C224.248 95.0033 221.657 96.6005 218.765 97.2311C215.872 97.8618 212.851 97.4882 210.2 96.1721C207.548 94.856 205.424 92.6758 204.177 89.9908C202.931 87.3058 202.636 84.2762 203.342 81.4013C204.048 78.5264 205.712 75.9777 208.06 74.1752C210.408 72.3727 213.301 71.424 216.26 71.4854C219.22 71.5468 222.07 72.6147 224.342 74.513C225.813 75.7428 226.995 77.2824 227.803 79.0219C228.61 80.7614 229.024 82.6577 229.014 84.5755Z",
    fill: "#04B2AE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M225.075 78.9263C225.072 81.4018 224.363 83.8251 223.032 85.9123C221.701 87.9995 219.802 89.6641 217.559 90.711C215.316 91.758 212.821 92.1439 210.366 91.8236C207.911 91.5033 205.599 90.49 203.699 88.9025C203.011 86.938 202.803 84.8372 203.092 82.7757C203.382 80.7143 204.161 78.7522 205.364 77.0535C206.567 75.3548 208.16 73.969 210.009 73.0118C211.857 72.0547 213.908 71.5541 215.99 71.5519C219.045 71.5452 222.003 72.6197 224.342 74.585C224.836 75.9787 225.084 77.4476 225.075 78.9263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M394.024 248.781C394.024 250.63 393.476 252.437 392.448 253.974C391.421 255.51 389.961 256.708 388.253 257.415C386.545 258.122 384.665 258.306 382.852 257.944C381.039 257.582 379.374 256.691 378.068 255.383C376.762 254.075 375.873 252.409 375.514 250.595C375.156 248.782 375.343 246.902 376.052 245.195C376.761 243.488 377.961 242.03 379.5 241.005C381.038 239.98 382.846 239.434 384.695 239.437C387.169 239.445 389.54 240.432 391.288 242.183C393.037 243.934 394.02 246.307 394.024 248.781Z",
    fill: "#04B2AE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M391.207 244.727C391.208 246.504 390.703 248.244 389.751 249.744C388.799 251.243 387.439 252.44 385.831 253.195C384.223 253.949 382.433 254.229 380.671 254.003C378.909 253.776 377.248 253.052 375.883 251.915C375.387 250.506 375.235 248.998 375.442 247.519C375.648 246.039 376.206 244.631 377.069 243.411C377.932 242.192 379.075 241.198 380.402 240.511C381.729 239.825 383.201 239.466 384.695 239.466C386.885 239.46 389.005 240.234 390.675 241.651C391.033 242.637 391.213 243.679 391.207 244.727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M115.61 253.913C115.621 256.993 114.54 259.976 112.558 262.334C110.576 264.691 107.822 266.268 104.786 266.786C101.75 267.303 98.6294 266.727 95.9786 265.16C93.3277 263.592 91.3189 261.135 90.3095 258.226C89.812 256.842 89.559 255.383 89.562 253.913C89.562 250.459 90.9342 247.146 93.3766 244.704C95.819 242.261 99.1317 240.889 102.586 240.889C106.04 240.889 109.353 242.261 111.795 244.704C114.237 247.146 115.61 250.459 115.61 253.913Z",
    fill: "#04B2AE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M111.685 248.264C111.687 249.974 111.351 251.669 110.698 253.25C110.044 254.831 109.085 256.267 107.875 257.477C106.665 258.687 105.229 259.646 103.648 260.3C102.067 260.954 100.372 261.289 98.6614 261.287C95.6049 261.29 92.6461 260.21 90.3095 258.24C89.812 256.857 89.559 255.397 89.562 253.927C89.5683 251.453 90.2786 249.032 91.6097 246.946C92.9409 244.86 94.838 243.197 97.0795 242.149C99.321 241.101 101.814 240.713 104.268 241.03C106.722 241.346 109.035 242.355 110.938 243.937C111.434 245.325 111.687 246.789 111.685 248.264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M100.617 211.636C100.616 213.172 100.072 214.657 99.0824 215.831C98.0924 217.005 96.7195 217.791 95.2062 218.05C93.6928 218.31 92.1364 218.027 90.8118 217.25C89.4871 216.474 88.4795 215.254 87.9668 213.807C87.7185 213.11 87.592 212.376 87.593 211.636C87.593 209.909 88.2791 208.253 89.5003 207.032C90.7215 205.81 92.3778 205.124 94.1049 205.124C95.8319 205.124 97.4883 205.81 98.7095 207.032C99.9307 208.253 100.617 209.909 100.617 211.636Z",
    fill: "#04B2AE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M98.6618 208.89C98.6555 210.127 98.298 211.336 97.631 212.378C96.964 213.419 96.0148 214.249 94.8941 214.772C93.7735 215.295 92.5273 215.488 91.3009 215.33C90.0745 215.172 88.9182 214.668 87.9668 213.879C87.7185 213.182 87.592 212.448 87.593 211.708C87.5935 210.469 87.9475 209.256 88.6134 208.211C89.2793 207.166 90.2295 206.333 91.3524 205.809C92.4754 205.285 93.7244 205.093 94.9529 205.254C96.1814 205.415 97.3384 205.924 98.288 206.72C98.5374 207.416 98.6639 208.151 98.6618 208.89Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M159.669 183.59C159.668 185.126 159.124 186.612 158.134 187.785C157.144 188.959 155.772 189.745 154.258 190.005C152.745 190.264 151.188 189.981 149.864 189.204C148.539 188.428 147.531 187.208 147.019 185.761C146.769 185.065 146.643 184.33 146.645 183.59C146.649 181.866 147.337 180.213 148.557 178.995C149.778 177.777 151.432 177.093 153.157 177.093C154.881 177.093 156.536 177.777 157.756 178.995C158.977 180.213 159.665 181.866 159.669 183.59Z",
    fill: "#04B2AE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M157.699 180.773C157.703 182.012 157.351 183.226 156.687 184.272C156.023 185.318 155.074 186.152 153.951 186.676C152.829 187.201 151.58 187.393 150.351 187.231C149.123 187.069 147.967 186.559 147.019 185.761C146.769 185.065 146.643 184.33 146.645 183.59C146.649 181.866 147.337 180.213 148.557 178.995C149.778 177.777 151.432 177.093 153.157 177.093C154.682 177.084 156.16 177.619 157.326 178.602C157.575 179.299 157.702 180.033 157.699 180.773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M114.574 249.974L113.209 249.485L126.448 212.312L99.2649 210.946L99.3368 209.509L128.46 210.975L114.574 249.974Z",
    fill: "#04B2AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.357 212.355H127.454V210.917H145.251L151.489 187.429L152.884 187.802L146.357 212.355Z",
    fill: "#04B2AE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M351.431 329.065C352.223 328.48 353.199 328.198 354.181 328.271C355.163 328.344 356.086 328.768 356.783 329.464C357.479 330.16 357.902 331.083 357.975 332.066C358.049 333.048 357.767 334.023 357.181 334.815C356.914 335.2 356.578 335.531 356.189 335.793C355.293 336.408 354.19 336.643 353.121 336.447C352.052 336.251 351.104 335.639 350.485 334.746C349.865 333.853 349.625 332.751 349.816 331.681C350.006 330.611 350.613 329.66 351.503 329.036L351.431 329.065Z",
    fill: "#04B2AE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M350.684 331.078C351.327 330.636 352.082 330.385 352.862 330.356C353.642 330.327 354.414 330.521 355.087 330.914C355.761 331.308 356.309 331.885 356.667 332.578C357.025 333.272 357.179 334.053 357.109 334.83C356.842 335.214 356.506 335.546 356.118 335.807C355.476 336.256 354.719 336.511 353.937 336.543C353.155 336.575 352.38 336.383 351.704 335.988C351.028 335.593 350.479 335.013 350.123 334.316C349.766 333.619 349.617 332.835 349.692 332.055C349.959 331.671 350.295 331.34 350.684 331.078Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M348.528 298.835C349.321 298.287 350.282 298.036 351.242 298.127C352.201 298.218 353.098 298.644 353.775 299.331C354.451 300.017 354.864 300.921 354.94 301.882C355.016 302.843 354.751 303.8 354.191 304.585C353.924 304.969 353.588 305.301 353.199 305.562C352.303 306.124 351.224 306.319 350.187 306.106C349.15 305.893 348.236 305.288 347.634 304.417C347.032 303.547 346.789 302.478 346.955 301.432C347.122 300.387 347.685 299.446 348.528 298.806V298.835Z",
    fill: "#04B2AE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M347.766 300.89C348.209 300.577 348.711 300.356 349.241 300.237C349.77 300.119 350.319 300.107 350.853 300.202C351.388 300.297 351.898 300.497 352.355 300.79C352.812 301.084 353.207 301.464 353.516 301.911C354.057 302.708 354.306 303.668 354.22 304.628C353.953 305.012 353.616 305.344 353.228 305.605C352.585 306.048 351.83 306.298 351.05 306.327C350.27 306.356 349.498 306.162 348.824 305.769C348.151 305.375 347.603 304.798 347.244 304.105C346.886 303.412 346.733 302.631 346.802 301.853C347.061 301.476 347.388 301.149 347.766 300.89Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M356.405 331.337L355.93 329.985L382.984 320.196L373.54 305.016L399.113 298.102L399.486 299.482L375.782 305.893L385.14 320.944L356.405 331.337Z",
    fill: "#04B2AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.071 305.864L367.789 296.808L353.544 301.954L353.055 300.589L368.336 295.083L375.25 305.045L374.071 305.864Z",
    fill: "#04B2AE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M400.076 290.483C401.616 289.407 403.478 288.889 405.352 289.015C407.226 289.14 409.002 289.901 410.385 291.173C411.768 292.444 412.676 294.149 412.958 296.007C413.241 297.864 412.881 299.762 411.939 301.387C410.996 303.012 409.527 304.267 407.775 304.944C406.023 305.621 404.092 305.68 402.302 305.111C400.511 304.542 398.969 303.379 397.929 301.814C396.889 300.25 396.414 298.377 396.583 296.506C396.689 295.308 397.057 294.147 397.661 293.106C398.264 292.066 399.089 291.17 400.076 290.483Z",
    fill: "#04B2AE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M398.566 294.551C399.852 293.662 401.365 293.158 402.927 293.098C404.488 293.037 406.035 293.424 407.385 294.211C408.736 294.999 409.834 296.155 410.55 297.544C411.267 298.933 411.573 300.498 411.432 302.055C410.379 303.504 408.881 304.57 407.167 305.09C405.453 305.61 403.615 305.556 401.935 304.936C400.254 304.316 398.821 303.164 397.855 301.655C396.889 300.147 396.442 298.364 396.583 296.578C397.118 295.79 397.79 295.103 398.566 294.551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M388.418 301.925L371.225 272.413L390.402 264.191L385.615 255.465L386.865 254.775L392.414 264.895L373.295 273.089L389.668 301.206L388.418 301.925Z",
    fill: "#04B2AE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M395.577 109.703C395.573 111.903 394.793 114.031 393.372 115.711C391.952 117.391 389.984 118.516 387.815 118.885C385.647 119.255 383.417 118.847 381.52 117.732C379.624 116.617 378.182 114.868 377.45 112.794C377.095 111.797 376.915 110.747 376.918 109.689C376.918 107.211 377.902 104.834 379.655 103.082C381.407 101.329 383.784 100.345 386.262 100.345C388.74 100.345 391.116 101.329 392.869 103.082C394.621 104.834 395.605 107.211 395.605 109.689L395.577 109.703Z",
    fill: "#04B2AE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M392.759 105.649C392.761 106.875 392.521 108.089 392.053 109.222C391.585 110.354 390.898 111.384 390.031 112.25C389.164 113.117 388.135 113.804 387.002 114.272C385.87 114.741 384.656 114.981 383.43 114.979C381.239 114.989 379.118 114.214 377.45 112.794C377.095 111.797 376.915 110.747 376.918 109.689C376.916 107.912 377.421 106.172 378.374 104.672C379.326 103.173 380.686 101.976 382.294 101.221C383.902 100.467 385.692 100.187 387.454 100.413C389.216 100.64 390.877 101.364 392.242 102.501C392.593 103.513 392.768 104.578 392.759 105.649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M389.971 162.847L372.778 133.321L391.954 125.113L387.167 116.387L388.418 115.697L393.967 125.803L374.834 134.011L391.207 162.129L389.971 162.847Z",
    fill: "#04B2AE"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 271.5,
    cy: 49,
    rx: 71.5,
    ry: 20,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_480_351",
    x: 0,
    y: 0.956421,
    width: 525.543,
    height: 478.781,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0205556 0 0 0 0 0.264876 0 0 0 0 0.308333 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_480_351"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_480_351",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_480_351",
    x1: 279.326,
    y1: 247.329,
    x2: 190.877,
    y2: 288.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_480_351",
    x1: 270.917,
    y1: 158.175,
    x2: 148.715,
    y2: 152.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_480_351",
    x1: 219.254,
    y1: 165.047,
    x2: 269.71,
    y2: 232.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_480_351",
    x1: 286.787,
    y1: 208.359,
    x2: 174.633,
    y2: 212.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_480_351",
    x1: 204.317,
    y1: 192.388,
    x2: 312.834,
    y2: 260.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_480_351",
    x1: 266.95,
    y1: 136.412,
    x2: 165.361,
    y2: 183.878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_480_351",
    x1: 179.923,
    y1: 215.589,
    x2: 248.319,
    y2: 203.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_480_351",
    x1: 184.552,
    y1: 276.079,
    x2: 325.556,
    y2: 251.627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_480_351",
    x1: 274.022,
    y1: 385.573,
    x2: 286.729,
    y2: -4.6644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#04B2AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#04B2AE",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#04B2AE",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#04B2AE",
    stopOpacity: 0.47
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#04B2AE",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#04B2AE",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#04B2AE",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#04B2AE",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#04B2AE",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#04B2AE",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04B2AE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechEyeIllus);
export default __webpack_public_path__ + "static/media/Tech Eye Illus.c1f6b71030bba672ec60fa4d9e92688c.svg";
export { ForwardRef as ReactComponent };